import { NAVIGATOR_CONFIG } from "../../headless/children";
import { PLATFORM } from "../../utils/platform";
import { convertFontWeightToStringFontWeight, flattenStyle } from "../../utils/style";
function StackHeaderTitle(_props) {
  return null;
}
Object.assign(StackHeaderTitle, {
  [NAVIGATOR_CONFIG]: true
});
function appendStackHeaderTitlePropsToOptions(options, props) {
  var flattenedStyle = flattenStyle(props.style);
  var flattenedLargeStyle = flattenStyle(props.largeStyle);
  var titleStyle = flattenedStyle ? {
    ...flattenedStyle,
    ...(flattenedStyle === null || flattenedStyle === void 0 ? void 0 : flattenedStyle.fontWeight) ? {
      fontWeight: convertFontWeightToStringFontWeight(flattenedStyle.fontWeight)
    } : {}
  } : void 0;
  var largeTitleStyle = flattenedLargeStyle ? {
    ...flattenedLargeStyle,
    ...(flattenedLargeStyle === null || flattenedLargeStyle === void 0 ? void 0 : flattenedLargeStyle.fontWeight) ? {
      fontWeight: convertFontWeightToStringFontWeight(flattenedLargeStyle.fontWeight)
    } : {}
  } : void 0;
  return {
    ...options,
    title: props.children,
    headerLargeTitleEnabled: props.large,
    // Large titles on iOS require headerTransparent for proper scroll behavior
    // Only set on iOS since headerLargeTitleEnabled is iOS-only
    ...props.large && PLATFORM === "ios" && {
      headerTransparent: true
    },
    headerTitleAlign: flattenedStyle === null || flattenedStyle === void 0 ? void 0 : flattenedStyle.textAlign,
    // Only set styles when explicitly configured to avoid interfering with native defaults
    ...titleStyle && Object.keys(titleStyle).length > 0 && {
      headerTitleStyle: titleStyle
    },
    ...largeTitleStyle && Object.keys(largeTitleStyle).length > 0 && {
      headerLargeTitleStyle: largeTitleStyle
    }
  };
}
export {
  StackHeaderTitle,
  appendStackHeaderTitlePropsToOptions
};
//# sourceMappingURL=StackHeaderTitle.js.map
